/* eslint-disable import/no-unresolved */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Slider from "react-multi-carousel";
import * as Actions from "actions";
import {Box, Container, Grid} from "@mui/material";

import MockProductBox from "components/elements/main/MockProductBox";
import CustomSectionCreator from "components/CustomSectionCreator";
import {Pace} from "components/Atoms";
import AdminShopSupportTicketItem from "../AdminShopSupportTicketItem";
import AdminShopSalesLogItem from "../AdminShopSalesLogItem";

const AdminShopSupportTicketList = (props) => {

  const { adminGetShopSupportTickets, adminGetShopSalesLog, shopId, isLoading, supporttickets, saleslog } = props;

    useEffect(() => {
        adminGetShopSupportTickets(shopId);
        adminGetShopSalesLog(shopId);
    }, []);

    const renderResults = () => (
        <Container>
            <Box mt={4}>
                {isLoading && <Pace color="#27ae60" height="2px" />}
                {<CustomSectionCreator isSubtle={false} title="Recent Support Tickets" /> }
                {supporttickets && supporttickets.map((supportticket, index) => (
                    <AdminShopSupportTicketItem supportticket={supportticket} />
                ))}
            </Box>
            <Box mt={4}>
                {isLoading && <Pace color="#27ae60" height="2px" />}
                {<CustomSectionCreator isSubtle={false} title="Recent Sales Visits" /> }
                {saleslog && saleslog.map((saleslog, index) => (
                    <AdminShopSalesLogItem supportticket={saleslog} />
                ))}
            </Box>

        </Container>
    );

  return (
      <>
      {isLoading ? <MockProductBox />
              : supporttickets.length > 0
                  ? renderResults()
                  : ""}


      </>
  );
};

AdminShopSupportTicketList.propTypes = {
    searchkeywords: PropTypes.objectOf(PropTypes.any).isRequired,
    adminSearchShopKeywords: PropTypes.func.isRequired,
};

// Mapping Props and State.
const adminShopSupportTicketList = connect(
  ({ adminShops, bootupInfo }) => ({
      userDetails: bootupInfo.userDetails,
      reqStatus: adminShops.reqStatus,
      isLoading: adminShops.isLoading,
      serviceError: adminShops.serviceError,
      supporttickets: adminShops.supporttickets,
      saleslog: adminShops.saleslog,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(AdminShopSupportTicketList);

export { adminShopSupportTicketList as default };
